import { DengueStageInteractor, DengueStageRequest, DengueStageStructRequest } from "../../Coordinator/DengueStage/DengueStageInteractor";

export class DengueStageViewModel {
    private interactor: DengueStageInteractor;

	constructor() {
		this.interactor = new DengueStageInteractor();
	}

    public fetchSave(obj: any): PromiseLike<any> {
        var request = new DengueStageRequest(
            obj["sgepfasedengue"] ? parseInt(obj["sgepfasedengue"]) : 0,
            obj["nome"] ? obj["nome"] : ""
        )
        
        return new Promise((res, rej) => {
			this.interactor.fetchSave(request).then((result) => {
				return res(result)
			}, e => {
				return rej(e)
			});
		})
    }

    public fetchDataOne(obj: any): PromiseLike<any> {
        var request = new DengueStageStructRequest(
            obj["sgepfasedengue"] ? parseInt(obj["sgepfasedengue"]) : 0
        )
        
        return new Promise((res, rej) => {
			this.interactor.fetchDataOne(request).then((result) => {
				return res(result)
			}, e => {
				return rej(e)
			});
		})
    }
}